<template>
  <path d="M18 0v6h6v2h-7a1 1 0 0 1-1-1V0h2zM6 24v-6H0v-2h7a1 1 0 0 1 1 1v7H6z" fill="#000" fill-rule="nonzero"/>
</template>
